/* iceberg-ui */
import { Checklist, Flex } from '@auviknetworks/iceberg-ui';

/* MUI */
import { useTheme } from '@mui/material/styles';

/* Images */
import PictographPrimaryOneColorLightPurple from 'images/pictograph/SVG/pictograph-primary-oneColor-lightPurple.svg';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

const ListOfItems = ({ t }) => [
    t('Onboarding.deployAgent.setupDeployment'),
    t('Onboarding.deployAgent.configureDeployment'),
    t('Onboarding.deployAgent.completed')
];

export const DeployAgentChecklist = ({ MotionWrapper, stepNumberMap }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const { currentStep } = useParams();
    return (
        <>
            <Flex
                data-testid="onboardingDeployAgentChecklistStepImg"
                justifyContent="center"
                maxHeight="65%"
                width="100%"
            >
                <MotionWrapper key="onboardingDeployAgentChecklistStepMW">
                    <img
                        src={PictographPrimaryOneColorLightPurple}
                        alt={t('Pictograph.primaryLightPurple')}
                        width="240px"
                        data-testid="logoCloseUpImage"
                    />
                </MotionWrapper>
            </Flex>
            <Flex
                alignItems="center"
                data-testid="onboardingDeployAgentChecklistStep"
                flexDirection="column"
                mt={5}
                mx="4%"
            >
                <Checklist
                    cardProps={{
                        style: {
                            backgroundColor:
                                theme.palette.onboarding
                                    .checklistBackgroundColor
                        }
                    }}
                    currentItem={stepNumberMap[currentStep] - 1}
                    listItems={ListOfItems({ t })}
                    showSeparation
                    title={t('Onboarding.deployAgent.title')}
                    cardHeaderProps={{
                        style: { textTransform: 'capitalize' }
                    }}
                />
            </Flex>
        </>
    );
};
